exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-toolbar__content{z-index:9999!important}", ""]);

// exports
